import { render, staticRenderFns } from "./GiftMain.vue?vue&type=template&id=42b351e9&scoped=true&"
import script from "./GiftMain.vue?vue&type=script&lang=js&"
export * from "./GiftMain.vue?vue&type=script&lang=js&"
import style0 from "./GiftMain.vue?vue&type=style&index=0&id=42b351e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b351e9",
  null
  
)

export default component.exports